<template>
    <div class="quotesinfo">
        <UserHeaderMenu/>
        <div class="container mt-3">
            <div class="row justify-content-left"><router-link to="/"><b-col lg="4" class="pb-2"><b-button :style="{'background':companyData.color, 'border':'none'}" size="sm">Vissza</b-button></b-col></router-link>
                <b-col lg="0" class="pb-2"><b-button :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="createPDF">Megtekintés PDF ként</b-button></b-col>
				<!--<b-col lg="2" v-if="mainData.megrendelve == 0" class="pb-2"><b-button :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="order">Megrendelem</b-button></b-col>-->
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <h5 class="mt-3">Árajánlat információk</h5>
                    <div class="col-lg-12 border mt-3">
                        <div class="row">
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Megnevezés:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.megnev}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Azonosító:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.arajanlatszam}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Megrendel:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.ugyfel_cegnev}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Telefonszám:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.keszito_tel}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Kiállítás dátuma:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.keszito_datum}}
                            </div>
                        </div>
                    </div>
                    <h5  v-if="prodImage !== null" class="mt-3">Termék képe</h5>
                    <img v-if="prodImage !== null" style="width:200px" class="mb-2 mt-2" :src="setImgSrc(prodImage)"> 
                    <h5 class="mt-3">Paraméterek</h5>
                    <div class="col-lg-12 border mt-3">
                        <div class="row" v-for="item in techData" :key="item.id">
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                {{item.adat_megnev}}
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{item.adat_ertek}}
                            </div>
                        </div>
                    </div>
                    <h5 class="mt-3 ">Kalkulált ár</h5>
                    <div class="col-lg-12 border mt-3">
                        <div class="row bg-light-gray">
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                <span class="d-none d-lg-block d-md-block">Mennyiség</span>
                                <span class="d-block d-lg-none d-md-none">Darab</span>
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                Ár
                            </div>
                            <div class="col-2 p-2 pl-lg-5 pl-md-5 pl-0 left-data">
                                Ktd ár
                            </div>
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                <span class="d-none d-lg-block d-md-block">Össz súly</span>
                                <span class="d-block d-lg-none d-md-none">Súly</span>
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                <span class="d-none d-lg-block d-md-block">Megrendelés</span>
                                <span class="d-block d-lg-none d-md-none"></span>
                            </div>
                        </div>
                        <div class="row overflow-auto" v-for="item in priceData" :key="item.id">
                            <template v-if="item.ordered == 0">
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 border-top">
                                {{item.mennyiseg}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 border-top">
                                {{numberWithSpace(item.ar)+" "+item.penznem}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 border-top">
                                {{numberWithSpace(item.ktd_ar)+" "+item.penznem}}
                            </div>
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 pr-0 border-top">
                                {{item.ossz_suly}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 pr-0 border-top">
                                <b-button v-if="item.megrendelve == 0" :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="order(item.sorszam)">Megrendelem</b-button>
								<b-button v-else :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="reorder(item.sorszam)">Újra rendelem</b-button>
                            </div>
                            </template>

                            <template v-if="item.ordered == 1">
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 border-top table-success">
                                {{item.mennyiseg}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 border-top table-success">
                                {{numberWithSpace(item.ar)+" "+item.penznem}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 border-top table-success">
                                {{numberWithSpace(item.ktd_ar)+" "+item.penznem}}
                            </div>
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 pr-0 border-top table-success">
                                {{item.ossz_suly}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 pr-0 border-top table-success">
                                <b-button v-if="item.megrendelve == 0" :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="order(item.sorszam)">Megrendelem</b-button>
								<b-button v-else :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="reorder(item.sorszam)">Újra rendelem</b-button>
                            </div>
                            </template>

                        </div>
						<div class="row overflow-auto">
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 border-top">
                                    <b-form-input v-model="qty_egyedi" type="number" @keyup="changeQty()" placeholder="Egyedi mennyiség"></b-form-input>
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 border-top">
                                {{qty_ar}} {{qty_nem}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 border-top">
                                {{qty_ktd}} {{qty_nem}}
                            </div>
                            <div class="col-3 p-2 pl-0 pl-lg-5 pl-md-5 pr-0 border-top">
                                {{qty_suly}}
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 pr-0 border-top">
                                <b-button :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="orderQty()">Megrendelem</b-button>
                            </div>
                        </div>
                    </div>
                    <h5 class="mt-3">Szerszám használat</h5>
                    <div class="col-lg-12 border mt-3 mb-5"  v-if="toolsData[0] != null">
                        <div class="row" v-for="item in toolsData" :key="item.id">
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                {{item.szerszam_megnev}}
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{numberWithSpace(item.szerszam_ertek)}}
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-lg-12 border mt-3  mb-5">
                        <div class="row">
                            <div class="col-lg-12 bg-light-gray p-2 pl-0 left-data text-center">
                                Nincs szerszám költség
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SettingsModal/>
    </div>
</template>
<script>
import jsPDF from 'jspdf'
import axios from 'axios'
import SettingsModal from '../components/SettingsModal.vue'
import UserHeaderMenu from '../components/UserHeaderMenu.vue'

export default {
  components: {
    SettingsModal,
    UserHeaderMenu
  },
  name: 'quotesinfo',
data(){
    return {
		product_image:[],
        priceData:[],
        mainData:[],
        techData:[],
        toolsData:[],
		companyData:[],
		prodImage64:"",
        base64Header:"",
		base64Logo:"",
		qty_egyedi:"",
		qty_ar:"",
		qty_ktd:"",
		qty_suly:"",
		qty_nem:"",
		prodImage:""
      }
    },
    computed: {
      
	},
    methods:{
        numberWithSpace(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        setImgSrc(img){
            return "https://admin.promagic.hu/api/uploads/"+img;
		},
		changeQty(){
			let params = new URLSearchParams();
            params.append('changeValue', true);
            params.append('arajanalatszam', this.mainData.arajanlatszam);
			params.append('user_id', this.$session.get('id'));
			params.append('qtyValue', this.qty_egyedi)
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
				console.log(response);
                this.qty_ar = response.data.ar
				this.qty_ktd = response.data.ktd_ar
				this.qty_suly = response.data.ossz_suly
				this.qty_nem = response.data.penznem
            })
		},
		orderQty(){
			if(this.qty_egyedi == ""){
				this.$swal('Kötelező megadni a mennyiséget', '' ,'warning')
			}else if(this.qty_egyedi<parseInt(this.priceData[0].mennyiseg)){
				this.$swal('A minimum igénylehető mennyiség '+parseInt(this.priceData[0].mennyiseg)+' darab' , '','warning')
			}else{
				const params = new URLSearchParams();
				params.append('sendSpecialOffer', true);
				params.append('user_id', this.$session.get('id'));
				params.append('qty', this.qty_egyedi)
				params.append('ar', this.qty_ar)
				params.append('ktd', this.qty_ktd)
				params.append('nem', this.qty_nem)
				params.append('suly', this.qty_suly)
				axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
                console.log(response);
				this.$swal('Arajánlat elfogadva', 'Hamarosan felvesszük veled a kapcsolatot' ,'success')
				this.loadMainData()
				this.loadTechData()
				this.loadToolsData()
				this.loadPriceData()
				this.getCompanyData()
			})
			}
		},
		reorder(mennyiseg_id){
            const params = new URLSearchParams();
			params.append('sendOrderAgain', true);
			params.append('user_id', this.$session.get('id'));
            params.append('id', this.mainData.arajanlatszam);
            params.append('id_mennyiseg', mennyiseg_id);
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
                console.log(response);
				this.$swal('Arajánlat elfogadva', 'Hamarosan felvesszük veled a kapcsolatot' ,'success')
				this.loadMainData()
				this.loadTechData()
				this.loadToolsData()
				this.loadPriceData()
				this.getCompanyData()
			})
		},
		order(mennyiseg_id){
			const params = new URLSearchParams();
			params.append('sendOrder', true);
			params.append('user_id', this.$session.get('id'));
            params.append('id', this.mainData.arajanlatszam);
            params.append('id_mennyiseg', mennyiseg_id);
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
                console.log(response);
				this.$swal('Arajánlat elfogadva', 'Hamarosan felvesszük veled a kapcsolatot' ,'success')
				this.loadMainData()
				this.loadTechData()
				this.loadToolsData()
				this.loadPriceData()
				this.getCompanyData()
			})
		},
		uploadImage(){
		if(this.product_image != ""){
			let formData = new FormData();
			formData.append('uploadProdImage', this.product_image);
			formData.append('user_id', this.$session.get('id'));
			formData.append('azonosito', this.mainData.arajanlatszam);
			axios.post(process.env.VUE_APP_ADMIN_API,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(() => {
				this.$swal('Kép sikeresen frissítve', 'Most már nyomtatáskor szerepelni fog a PDF-ben' ,'success')
				this.loadLastProductImage()
				const params4 = new URLSearchParams();
                params4.append('convertImageToBase64', true);
                params4.append('url', this.prodImage);
                params4.append('user_id', this.$session.get('id'));
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_QUOTES_API,
                    data:params4
                }).then((response) => {
                    this.prodImage64 = response.data
				})
			})
		}else{
			this.$swal('Kép feltöltés sikertelen', 'Kötelező fájlt kiválasztani' ,'error')
		}
    },
        createPDF () {
            let pdfName = this.mainData.ugyfel_cegnev;
            const doc = new jsPDF();
            //Banner behúzás
			doc.addImage('data:image/jpeg;base64,'+this.base64Header, "JPEG", 10, 10, 190, 20);
			if(this.prodImage != "" && this.prodImage != null){
				doc.addImage('data:image/jpeg;base64,'+this.prodImage64, "JPEG", 160, 75, 30, 30);
			}
            doc.setFontStyle("bold");
            doc.setFontSize(13);
            doc.text("Árajánlat - tekercses címke", 10, 40);
            doc.setLineWidth(0.5);
            doc.line(10, 43, 200, 43);
            doc.setFontSize(10);
            //Árajánlat rendelési adatok
            doc.text("Megrendelö:", 20, 48);
            doc.text(this.mainData.ugyfel_cegnev.replace('ő', 'ö').replace('ű', 'ü'), 80, 48);
            doc.text("Címzett:", 20, 53);
            doc.text(this.mainData.ugyfel_nev.replace('ő', 'ö').replace('ű', 'ü'), 80, 53);
            doc.text("Árajnlat száma:", 20, 58);
            doc.text(this.mainData.arajanlatszam.replace('ő', 'ö').replace('ű', 'ü'), 80, 58);
            doc.text("Árajánlat készítés ideje:", 20, 63);
            doc.text(this.mainData.datum, 80, 63);
            doc.text("Árajánlat készítö:", 20, 68);
            doc.text(this.mainData.name.replace('ő', 'ö').replace('ű', 'ü'), 80, 68);
            doc.setLineWidth(0.5); 
            doc.line(10, 71, 200, 71);
            //Árajánlat paraméterei
            doc.setFontSize(13);
            doc.text("Árajánlat paraméterei", 10, 77);
            doc.setFontSize(10);
            let i = 87;
            doc.text("Termék neve", 20, 82);
            this.techData.forEach(element => {
                doc.text(element.adat_megnev.replace('ő', 'ö').replace('ű', 'ü'), 20, i);    
                i+=5;
            });
            doc.setFontStyle("normal");
            doc.text(this.mainData.megnev.replace('ő', 'ö').replace('ű', 'ü'), 90, 82);
            i = 87;
            this.techData.forEach(element => {
                doc.text(element.adat_ertek.replace('ő', 'ö').replace('ű', 'ü'), 90, i);    
                i+=5;
            });
            i-=2;
            doc.setLineWidth(0.5); 
            doc.line(10, i, 200, i);
            i+=5;
            //Árajánlat tábla kilistázása
            doc.setFontSize(13);
            doc.setFontStyle("bold");
            doc.text("Kalkulált ár", 10, i);
            doc.setFontSize(10);
            i+=5;
            doc.text("Mennyiség", 20, i);
            doc.text("Ár *", 70, i);
            doc.setFontStyle("normal");
            doc.text("Összsúly", 110, i);
            doc.text("KTD", 160, i);
            i+=2;
            doc.line(10, i, 200, i);
            i += 5
            this.priceData.forEach(element => {
                this.addNewElementToRow(doc, i, element.mennyiseg, element.ar , element.ossz_suly, element.ktd_ar, element.penznem);
                i += 5
            });
            i += 8;
            this.toolsData.forEach(element => {
                doc.setFontStyle("bold");
                doc.text(element.szerszam_megnev+':', 90, i);
                doc.setFontStyle("normal");
                doc.text(this.numberWithSpace(element.szerszam_ertek)+' ', 120, i);
                if(i>263){
                doc.addPage();
                i=10;
                }
            });
            doc.setFontSize(8);
            i += 5
            doc.text("* Az árak az ÁFA -t nem tartalmazzák.", 80, i);
            doc.setFontSize(10);
			doc.setFontStyle("bold");
			if(this.mainData.tipus == 'Íves árajánlat'){
				i += 10
                doc.text("A darabáron felül továbbá az alábbi egyszeri költség fizetendö:", 10, i);
			}
            i += 3;
            doc.line(10, i, 200, i);
            i += 10;
            doc.setFontSize(7);
            doc.text(
"Az árajánlat a digitális proof készítését vagy a digitális mintanyomtatás költségét nem tartalmazza, melynek összege, igény esetén: 5000 Ft+Áfa, fajtánként.\n"+
"Megrendelés esetén kérem, szíveskedjen ajánlatunkra hivatkozni. Áraink tájékoztató jelleguek, a muveleti árat, az adott paraméterek mellett tárgyévre fixnek tekintjük.\n"+
"A termékek árát csak 5%-ot meghaladó alapanyag árváltozás esetén módosítjuk, elozetes egyeztetés után. Áraink az ÁFA-t, a szállítási költséget, valamint a \n"+
"Környezetvédelmi Termékdíjat nem tartalmazzák. A termékek elso megrendelésénél, a feldolgozott grafikai állomány ügyfél általi jóváhagyását követo 12 munkanapon \nbelül,"+
"míg változatlan újragyártásnál, a megrendelés visszaigazolását követo 6 munkanapon belül gyártjuk a termékeket.\n"+
"Reméljük, hogy árajánlatunk megfelel elképzelésinek.\n"+
"Amennyiben bármilyen kérdése, lszrevétele van, forduljon hozzánk bizalommal!\n", 10, i);
            i = 263;
            doc.setFontSize(10)
            doc.setFontStyle("bold");
            doc.text(this.companyData.name, 80, i);
            doc.addImage('data:image/jpeg;base64,'+this.base64Logo, "JPEG", 143, 258, 40, 22);
            i += 5;
            doc.setFontSize(8)
            doc.text(this.mainData.szekhely+"\n"+
            this.mainData.bank+"\n"+
            this.mainData.szamlaszam+"\n"+
            "Adószám: "+this.mainData.adoszam, 80, i);
            i += 20;
            doc.setFontStyle("normal");
            doc.text("PROCESS MAGIC PRESS - 'Kezébe adjuk az irányítást!' - www.promagic.hu", 10, i);
            i -= 4;
            doc.line(10, i, 200, i);
            doc.save(pdfName + '.pdf');
        },
        addNewElementToRow(doc ,i, qty, price, weight, ktd, currency){
            doc.setFontStyle("bold");
            doc.text(qty, 20, i);
            doc.text(this.numberWithSpace(price)+" "+currency, 70, i);
            doc.setFontStyle("normal");
            doc.text(weight+' ', 110, i);
            doc.text(this.numberWithSpace(ktd)+" "+currency, 160, i);
            doc.line(10, i+1, 200, i+1);
        },
        sendQuotes(){
            let params = new URLSearchParams();
            params.append('sendQuotes', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then(() => {
                this.mainData.statusz = "Kiküldve"
            })
        },
        loadMainData(){
            let params = new URLSearchParams();
            params = new URLSearchParams();
            params.append('getThisQuotesData', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
                this.mainData = response.data[0]
            })
        },
        loadTechData(){
            let params = new URLSearchParams();
            params = new URLSearchParams();
            params.append('getThisQuotesTechData', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
                this.techData = response.data
            })
        },
        loadToolsData(){
            let params = new URLSearchParams();
            params = new URLSearchParams();
            params.append('getThisQuotesToolsData', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
                this.toolsData = response.data
            })
        },
        loadPriceData(){
            let params = new URLSearchParams();
            params = new URLSearchParams();
            params.append('getThisQuotesPriceData', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_QUOTES_API,
                data:params
            }).then((response) => {
				this.priceData = response.data
				this.qty_egyedi = parseInt(this.priceData[0].mennyiseg)
				this.qty_ar = this.priceData[0].ar
				this.qty_ktd = this.priceData[0].ktd_ar
				this.qty_suly = this.priceData[0].ossz_suly
				this.qty_nem = this.priceData[0].penznem
            })
		},
		loadLastProductImage(){
            if(this.prodImage != null || this.prodImage != ""){
                let params = new URLSearchParams();
                params = new URLSearchParams();
                params.append('getProductImage', true);
                params.append('azonosito', this.mainData.arajanlatszam);
                params.append('user_id', this.$session.get('id'));
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_QUOTES_API,
                    data:params
                }).then((response) => {
                    this.prodImage = response.data
                    const params4 = new URLSearchParams();
                    params4.append('convertImageToBase64', true);
                    params4.append('url', this.prodImage);
                    params4.append('user_id', this.$session.get('id'));
                    axios({
                        method: 'post',
                        url: process.env.VUE_APP_QUOTES_API,
                        data:params4
                    }).then((response) => {
                        this.prodImage64 = response.data
                    })
                })
            }
        },
        getCompanyData(){
            const params = new URLSearchParams();
            params.append('getCompanyData', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_LOGIN_API,
                data:params
            }).then((response) => {
                console.log(response.data[0])
                this.companyData = response.data[0]
                const params2 = new URLSearchParams();
                params2.append('convertImageToBase64', true);
                params2.append('url', this.companyData.pdf_header);
                params2.append('user_id', this.$session.get('id'));
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_QUOTES_API,
                    data:params2
                }).then((response) => {
                    this.base64Header = response.data
                })
                const params3 = new URLSearchParams();
                params3.append('convertImageToBase64', true);
                params3.append('url', this.companyData.logo_src);
                params3.append('user_id', this.$session.get('id'));
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_QUOTES_API,
                    data:params3
                }).then((response) => {
                    this.base64Logo = response.data
				})
				this.loadLastProductImage()
            })
        },
        moneyFormatting(price, type){
            return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: type }).format(price);
        },
    },
    mounted(){
        this.loadMainData()
        this.loadTechData()
        this.loadToolsData()
        this.loadPriceData()
		this.getCompanyData()
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Merienda&display=swap');
.bg-light-gray{
    background:#e5e5e5;
}
.left-data{
    font-weight: bold;
    font-size: 12pt;
}
</style>
